import { CountryIso2Code, LocaleId } from '@domgen/dgx-fe-i18n';
import { PossibleNowRequest } from '../../models/possible-now/possible-now-request.interface';
import { PossibleNowSource } from '../../models/possible-now/possible-now-source.enum';

export const mockPossibleNowRequest: PossibleNowRequest = {
  ContactElement: { email: 'bob@ross.com' },
  customerdate: '2022-01-01',
  FilterID: 'AMANA_US_GLOBAL_EMAIL',
  PreferenceAttributes: [
    {
      Key: 'country',
      Value: CountryIso2Code.UnitedStates,
    },
    {
      Key: 'language',
      Value: LocaleId.English_US,
    },
    {
      Key: 'disclosureLang',
      Value:
        'pass the actual text related to the box they check to acknowedge the Terms of Use and Privacy notice',
    },
    {
      Key: 'disclosurelVersion',
      Value: 'the disclosure version, if any',
    },
    {
      Key: 'consentVersion',
      Value: '2',
    },
    {
      Key: 'source',
      Value: PossibleNowSource.Web,
    },
    {
      Key: 'implied',
      Value: 'N',
    },
  ],
  PreferenceType: 1,
};
